import { render, staticRenderFns } from "./SlidingPage.vue?vue&type=template&id=424a56b0"
import script from "./SlidingPage.vue?vue&type=script&lang=js"
export * from "./SlidingPage.vue?vue&type=script&lang=js"
import style0 from "./SlidingPage.vue?vue&type=style&index=0&id=424a56b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports